import React from 'react';

import { IIconProps, TIconType } from '../interface';

const FolderIcon: TIconType = (props?: IIconProps) => {
	const color = props?.color || '#7070C2';

	return (
		<svg
			fill='none'
			height='16'
			viewBox='0 0 16 16'
			width='16'
			{...props?.innerSvgProps}
		>
			<path
				d='M2.66699 5.33203H13.3337V11.9987H2.66699V5.33203Z'
				fill={color}
				opacity='0.3'
			/>
			<path
				d='M13.333 4.0013H7.99967L6.66634 2.66797H2.66634C1.93301 2.66797 1.33967 3.26797 1.33967 4.0013L1.33301 12.0013C1.33301 12.7346 1.93301 13.3346 2.66634 13.3346H13.333C14.0663 13.3346 14.6663 12.7346 14.6663 12.0013V5.33464C14.6663 4.6013 14.0663 4.0013 13.333 4.0013ZM13.333 12.0013H2.66634V5.33464H13.333V12.0013Z'
				fill={color}
			/>
		</svg>
	);
};

export default FolderIcon;
